import {
  email as veeEmailValidator,
  max as veeMaxValidator,
  min as veeMinValidator,
  required as veeRequiredValidator,
} from '@vee-validate/rules'

/**
 * Валидация на длину номера телефона
 * @param value - номер телефона
 * @param phoneLength - длина на валидацию
 */
export const phoneRequired = (value: string, phoneLength: number) => {
  if (!value) return 'Поле не заполнено'

  if (value.length !== phoneLength) return 'Некорректный формат номера телефона'

  return true
}

/**
 * Валидация на наличие кода
 * @param value - строка проверки
 */
export const codeValidator = (value: string) => {
  if (!value) {
    return 'Поле не заполнено'
  }

  return true
}

/**
 * Валидация на корректность e-mail
 * @param value - e-mail
 */
export const emailValidator = (value: string) => {
  const latinInvalid = value.match(/[А-ЯЁа-яё]/)

  if (!veeEmailValidator(value) || latinInvalid) {
    return 'Некоpректный email адрес'
  }

  return true
}

/**
 * Валидация на наличие строки
 * @param value - строка проверки
 */
export const requiredValidator = (value: string) => {
  const isNotRequired = ['', null, undefined].includes(value)

  if (!veeRequiredValidator(value) || isNotRequired) {
    return 'Поле не заполнено'
  }

  return true
}

/**
 * Валидация минимальное количество символов в строке
 * @param value - значение на проверку
 * @param length - минимальное количество символов
 */
export const minValidator = (
  value: string | number,
  length: string | number,
) => {
  if (!veeMinValidator(value, { length })) {
    return `Строка должна состоять из ${length} и более символов`
  }

  return true
}

/**
 * Валидация на максимальное количество символов в строке
 * @param value - значение на проверку
 * @param length - максимальное количество символов
 */
export const maxValidator = (value: string | number, length: string | number) =>
  veeMaxValidator(value, { length })

/**
 * Валидация на Имя пользователя
 * @param str - строка проверки
 */
export const emojiValidator = (str: string) => {
  // https://www.freecodecamp.org/news/how-to-use-regex-to-match-emoji-including-discord-emotes/
  if (/<a?:.+?:\d{18}>|\p{Extended_Pictographic}/gu.test(str)) {
    return 'Имя должно состоять из букв'
  }

  return true
}

/**
 * Валидация на отсутствие выбора способа оплат
 * @param value - строка проверки
 */
export const requiredPaymentMethod = (value: string) => {
  if (!veeRequiredValidator(value)) {
    return 'Укажите способ оплаты'
  }

  return true
}

export const notActiveGift = (value: number | null) => {
  if (!value && typeof value !== 'number') return 'Выберите подарок'

  return true
}

export const maxNoteLength = (value: string) => {
  if (value && value.length > 300)
    return 'Превышено максимальное количество символов'

  return true
}

export const minPasswordLengthValidator = (value: string) => {
  const minLength = 6

  if (value.length < minLength) {
    return 'Пароль должен состоять из 6 и более символов'
  }

  return true
}
